// extracted by mini-css-extract-plugin
module.exports = {"player_video_box":"styles_player_video_box__1sb-Z","player_video_box__nodata":"styles_player_video_box__nodata__2vDy9"};